import { API_BASE_URL } from "./config";

// export const fetchGlobalSettings = async () => {
//     const url = `${API_BASE_URL}/global-settings`;
//     const res = await fetch(url);
//     if (!res.ok) throw new Error("Failed to fetch global settings");
//     const data = await res.json();
//     return data;
// };


export const fetchGlobalSettings = async () => {
    const url = `${API_BASE_URL}/global-settings?ts=${Date.now()}`;
    const res = await fetch(url, { cache: "no-store" });
    return res.json();
};
